import mask from '__jsLibs/mask';
import calc from './calc';
import popup from './popup';
import animateScrollTo from 'animated-scroll-to';
let timer;
let timerUpdate;

export default {
	namespaced: true,

	modules: {
		calc,
		popup
	},

	state: {
		items:           {},
		url:             null,
		recalculateUrl:  null,
		header:          null,
		count:           0,
		data:            {},
		toastr:          null,
		err:             [],
		validForm:       true,
		imageChanged:    false,
		autosaveEnabled: false,
		images:          []
	},

	getters: {
		items:          state => state.items,
		url:            state => state.url,
		recalculateUrl: state => state.recalculateUrl,
		header:         state => state.header,
		// amortization:   state => state.amortization,
		// maintenance:    state => state.maintenance,
		// inputs:         state => state.inputs,
		// tenants:        state => state.tenants,
		count:          state => state.count,
		data:           state => state.data,
		toastr:         state => state.toastr,
		err:            state => state.err,
		validForm:      state => state.validForm,
	},

	mutations: {
		setImages(state, payload) {
			state.images = payload;
			// state.createUpdateDeal.steps.items['Add a picture'].fields.images.updateValue = payload;
			// state.imageChanged = true;
		},
		setImageChanged(state, payload) {
			state.imageChanged = payload;
		},
		setAutosaveEnabled(state, payload) {
			state.autosaveEnabled = payload;
		},
		setItems(state, payload) {
			state.items = payload;
		},
		updateItemValue(state, { name, field, value }) {
			state.items[name].fields[field].updateValue = value;
			state.items[name].fields[field].value = value;
		},
		disabledItem(state, { name, field, disabled = false }) {
			state.items[name].fields[field].disabled = disabled;
		},

		setUrl(state, payload) {
			state.url = payload;
		},

		setRecalculateUrl(state, payload) {
			state.recalculateUrl = payload;
		},

		setHeader(state, payload) {
			state.header = payload;
			axios.defaults.headers[payload.name] = payload.value;
		},

		setCount(state, payload) {
			state.count = payload;
		},

		setToastr(state, payload) {
			state.toastr = payload;
		},

		setErr(state, payload) {
			state.err = payload;
		},

		setValidForm(state, items) {
			let arr = [];
			for (const key in items) {
				const element = items[key];
				for (const k in element.fields) {
					const field = element.fields[k];
					if (Array.isArray(field.error)) {
						arr.push(field.error);
					}
				}
			}

			state.validForm = !(arr.length > 0);
		},

		buildData(state, payload) {
			state.data = new FormData();
			for (const key in payload) {
				for (const k in payload[key].fields) {
					if (k !== 'images') {
						state.data.append(k.toString(), payload[key].fields[k].updateValue === '' ? '' : payload[key].fields[k].updateValue === null ? '' : payload[key].fields[k].updateValue);
					}
					else {
						// if (state.imageChanged) {
						// 	state.data.append(k.toString(), payload[key].fields[k].updateValue[0]);
						// }
						// else {
						state.data.append(k.toString(), null);
						// }
					}
					for (const j in payload[key].fields[k].subfields) {
						const element = payload[key].fields[k].subfields[j];
						for (const i in element) {
							const el = element[i];
							state.data.append(i.toString(), el.updateValue === '' ? '' : el.updateValue === null ? '' : el.updateValue);
						}
					}
				}
			}
		}
	},

	actions: {
		async RECALCULATE({ state, commit, dispatch }) {
			axios.defaults.headers.get[state.header.name] = state.header.value;
			axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
			await axios
				.get(state.recalculateUrl)
				.then(response => {
					commit('calc/setConstants', response.data);
					dispatch('calc/UPDATE_CALC');
					setTimeout(() => {
						dispatch('calc/UPDATE_CALC');
					}, 0);
				})
				.catch(err => {
					throw new Error(err);
				});
		},

		async SEND({ state, commit, dispatch, rootState }, cb) {
			commit('main/setLoad', true, { root: true });
			clearTimeout(timer);
			clearTimeout(timerUpdate);
			commit('buildData', state.items);
			commit('main/setLoad', true, { root: true });
			commit('setToastr', /* template */`
				<div class='toastr'>
					<div class="toastr__check"></div>
					<p class="toastr__text">
						Saved
					</p>
				</div>
			`);
			axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
			axios.defaults.headers.post[state.header.name] = state.header.value;
			let url = `/deals/${rootState.createUpdateDeal.id}/review/`;
			try {
				const response = await axios.post(state.url, state.data);
				if (response.data.deal) {
					for (let i = 0; i < state.images.length; i++) {
						const image = state.images[i];
						await axios.post('/api/deals-images/', {
							deal:  response.data.deal,
							file: image.blob
						});
					}
					window.location.href = `/deals/${response.data.deal}/edit`;
					return;
				}
				if (response.data.url) {
					window.location.href = response.data.url;
				}
				else {
					commit('createUpdateDeal/steps/setImageChanged', false, { root: true });
					commit('setItems', null);
					commit('setValidForm', response.data.items);
					commit('setAutosaveEnabled', true);

					for (const key in response.data.items) {
						const element = response.data.items[key];
						for (const k in element.fields) {
							const field = element.fields[k];
							field.updateValue = field.value;
							if (field.value === 'null') field.value = null;
							field.activeMask = mask(field);
							if (field.mask === 'percent' && field.value) field.value += '%';
							for (const j in field.subfields) {
								for (const i in field.subfields[j]) {
									const subfield = field.subfields[j][i];
									subfield.parentGroup = key;
									subfield.parent = k;
									subfield.updateValue = subfield.value;
									if (field.value === 'null') field.value = null;
									subfield.activeMask = mask(subfield);
									if (field.mask === 'percent') field.value += '%';
								}
							}
						}
					}
					commit('setErr', response.data.form_errors);
					if (state.err.length > 0) {
						commit('setToastr', /* template */`
							<div class='toastr'>
								<div class="toastr__err"></div>
								<p class="toastr__text">
									Your limit of 1 deals was reached. You cannot create more deals.
								</p>
							</div>
						`);
					}
					if (state.validForm) cb.i(state.toastr);
					// commit('setUrl', response.data.url);
					timerUpdate = setTimeout(() => {
						commit('main/setLoad', false, { root: true });
						commit('setItems', response.data.items);
					}, 0);
					commit('setRecalculateUrl', response.data.recalculate_url);
					dispatch('RECALCULATE');

					timer = setTimeout(() => {
						if (document.querySelector('.input__field.is-error')) {
							animateScrollTo(document.querySelector('.input__field.is-error'), {
								offset: -30
							});
						}
					}, 300);
				}
			}
			catch (err) {
				commit('main/setLoad', false, { root: true });
				if (err.response?.data?.message) {
					commit('setToastr', /* template */`
							<div class='toastr'>
								<div class="toastr__err"></div>
								<p class="toastr__text">
									${err.response.data.message}
								</p>
							</div>
						`);
					cb.i(state.toastr);
				}
				else {
					commit('setToastr', /* template */`
							<div class='toastr'>
								<div class="toastr__err"></div>
								<p class="toastr__text">
									server error
								</p>
							</div>
						`);
					cb.i(state.toastr);
				}

				// throw new Error(err);
			}
			finally {
				// commit('main/setLoad', false, { root: true });
			}
		},
		async SEND_REVIEW({ state, commit, dispatch, rootState }, cb) {
			commit('setAutosaveEnabled', true);
			commit('main/setLoad', true, { root: true });
			clearTimeout(timer);
			clearTimeout(timerUpdate);
			commit('buildData', state.items);
			commit('main/setLoad', true, { root: true });
			commit('setToastr', /* template */`
				<div class='toastr'>
					<div class="toastr__check"></div>
					<p class="toastr__text">
						Saved
					</p>
				</div>
			`);
			axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
			axios.defaults.headers.post[state.header.name] = state.header.value;
			let url = `/deals/${rootState.createUpdateDeal.id}/review/`;
			await axios
				.post(url, state.data)
				.then(response => {
					commit('setItems', null);
					commit('setValidForm', response.data.items);

					for (const key in response.data.items) {
						const element = response.data.items[key];
						for (const k in element.fields) {
							const field = element.fields[k];
							field.updateValue = field.value;
							if (field.value === 'null') field.value = null;
							field.activeMask = mask(field);
							if (field.mask === 'percent' && field.value) field.value += '%';
							for (const j in field.subfields) {
								for (const i in field.subfields[j]) {
									const subfield = field.subfields[j][i];
									subfield.parentGroup = key;
									subfield.parent = k;
									subfield.updateValue = subfield.value;
									if (field.value === 'null') field.value = null;
									subfield.activeMask = mask(subfield);
									if (field.mask === 'percent') field.value += '%';
								}
							}
						}
					}
					commit('setErr', response.data.form_errors);
					if (state.err.length > 0) {
						commit('setToastr', /* template */`
						<div class='toastr'>
							<div class="toastr__err"></div>
							<p class="toastr__text">
								Your limit of 1 deals was reached. You cannot create more deals.
							</p>
						</div>
					`);
					}
					if (state.validForm) cb.i(state.toastr);
					commit('setUrl', response.data.url);
					timerUpdate = setTimeout(() => {
						commit('main/setLoad', false, { root: true });
						commit('setItems', response.data.items);
					}, 0);
					commit('setRecalculateUrl', response.data.recalculate_url);
					dispatch('RECALCULATE');

					timer = setTimeout(() => {
						if (document.querySelector('.input__field.is-error')) {
							animateScrollTo(document.querySelector('.input__field.is-error'), {
								offset: -30
							});
						}
					}, 300);
				})
				.catch(err => {
					commit('main/setLoad', false, { root: true });
					if (err.response.data.message) {
						commit('setToastr', /* template */`
							<div class='toastr'>
								<div class="toastr__err"></div>
								<p class="toastr__text">
									${err.response.data.message}
								</p>
							</div>
						`);
						cb.i(state.toastr);
					}
					else {
						commit('setToastr', /* template */`
							<div class='toastr'>
								<div class="toastr__err"></div>
								<p class="toastr__text">
									server error
								</p>
							</div>
						`);
						cb.i(state.toastr);
					}

					throw new Error(err);
				});
			commit('main/setLoad', false, { root: true });
		},

		async SEND_INTERVAL({ state, commit, dispatch }, cb) {
			if (state.autosaveEnabled) {
				commit('setToastr', /* template */`
					<div class='toastr'>
						<div class="toastr__check"></div>
						<p class="toastr__text">Saved</p>
					</div>
				`);
				commit('buildData', state.items);
				axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
				axios.defaults.headers.post[state.header.name] = state.header.value;
				await axios
					.post(state.url, state.data)
					.then(response => {
						commit('setValidForm', response.data.items);
						commit('setErr', response.data.form_errors);
						if (state.err.length > 0) {
							commit('setToastr', /* template */`
								<div class='toastr'>
									<div class="toastr__err"></div>
									<p class="toastr__text">
										Your limit of 1 deals was reached. You cannot create more deals.
									</p>
								</div>
							`);
						}
						if (state.validForm) cb.i(state.toastr);
						commit('setUrl', response.data.url);
						commit('setRecalculateUrl', response.data.recalculate_url);
						dispatch('RECALCULATE');
					})
					.catch(err => {
						commit('main/setLoad', false, { root: true });
						if (err.response?.data?.message) {
							commit('setToastr', /* template */`
								<div class='toastr'>
									<div class="toastr__err"></div>
									<p class="toastr__text">
										${err.response.data.message}
									</p>
								</div>
							`);
							cb.i(state.toastr);
						}
						else {
							commit('setToastr', /* template */`
								<div class='toastr'>
									<div class="toastr__err"></div>
									<p class="toastr__text">
										server error
									</p>
								</div>
							`);
							cb.i(state.toastr);
						}
						throw new Error(err);
					});
			}
		}
	}
};
